export default "__VITE_ASSET__Lxt7go_l__"